/** saves list of states
@payload { Array }
*/
export const SAVE_TRANSFERS_REQUEST_STATUS = (state, payload) => {
  state.transfersRequestsStatusList = payload.smartTransferRequestStatusViewList
}

/** saves list of sent requests
@payload { Array }
*/
export const SAVE_TRANSFERS_SENT_REQUESTS_LIST = (state, { pageNumber, data }) => {
  state.transfersSentRequestsList = pageNumber === 1 ? data.requests : state.transfersSentRequestsList.concat(data.requests)
  state.transfersSentRequestsHasMore = data.hasMore
}

/* ***********************************************
*                  CLEAR MUTATIONS               *
*********************************************** */
export const CLEAR_FEATURE_STATE = (state, payload) => {
  state.transfersRequestsStatusList = []
  state.transfersSentRequestsList = []
  state.transfersSentRequestsHasMore = false
}
